module.exports = __webpack_public_path__ + "static/media/T5-NGINX.eae76401.svg";